// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__TqaR+","status":"style_status__4IpTJ","report":"style_report__KTr6H"};